export default "__VITE_ASSET__BSqYhiMO__"